import {Component, Input, OnInit} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExgMapPlacesServices} from 'exc-map-v2';
import {EnumerationService} from '../../services/enumeration.service';

@Component({
  selector: 'app-location-create',
  templateUrl: './modal-location-create.component.html',
  styles: [
  ]
})
export class ModalLocationCreateComponent extends ExcTranslation implements OnInit {

  @Input() data: any;
  newLocationArray = [];
  isAddMoreChecked = false;
  excRestService = ExcCoreModule.Services().ExcRest;
  modalStyle = {width: '800px', height: '600px', animation: 'zoom-in 300ms ease-out forwards'};

  locName = '';
  placesList = [] as any[];
  selectedLocation: any;
  locActive = false;
  locNew = false;
  MapZoom = 13;

  showManuel = false;
  changedManuel = false;

  predefinedAddressType = false;
  constructor(
    public modalService: ExgModalService,
    public placesService: ExgMapPlacesServices,
    public enumSvc: EnumerationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.locActive = !this.data.new && this.data?.adrLng && this.data?.adrLat;
    this.locNew = this.data.new;

    this.selectedLocation = JSON.parse(JSON.stringify(this.data));

    if (this.data?.adr_enmIdent_AdresseTyp) {
      this.predefinedAddressType = true;
    }
    else {
      this.selectedLocation.adr_enmIdent_AdresseTyp = 2;
    }

    this.showManuel = !this.data.new && this.data?.adrID && !(this.data?.adrLng && this.data?.adrLat);
  }

  onSearch(input: string): void {
    this.placesService.autocomplete({input}).subscribe((response: any) => {
        const placesObject: any[] = [];
        if (response.length > 0) {
          response.forEach((obj: any) => {
            placesObject.push(obj);
          });
        }
        this.placesList = placesObject;
      });
  }

  onResultClick(index: number): void {
    const place = this.placesService.toPlace(this.placesList[index]);
    // @ts-ignore
    place.then( data => {
      if (data) {
        const countryCode = this.extractCountryCode(data?.place);
        this.assignLocationData(data.exgPlace, countryCode);
        this.locActive = true;
      }
    });
  }

  extractCountryCode(addressObject: any): string {
    if (!addressObject || !Array.isArray(addressObject.addressComponents)) {
      return '';
    }

    const countryComponent = addressObject.addressComponents.find((component: any) =>
      component.types.includes('country')
    );

    return countryComponent?.shortText || undefined;
  }

  assignLocationData(loc: any, countryCode: string): void {
    this.selectedLocation.adrBez = loc.name;
    this.selectedLocation.adrFormatted = loc.formatted;
    this.selectedLocation.adrHTML = loc.html;
    this.selectedLocation.adrStr = loc.street;
    this.selectedLocation.adrHNum = loc.street_number;
    this.selectedLocation.adrPlz = loc.zip;
    this.selectedLocation.adrOrt = loc.city;
    this.selectedLocation.adrLkz = countryCode;
    this.selectedLocation.adrLand = loc.country;
    this.selectedLocation.adrLat = loc.lat;
    this.selectedLocation.adrLng = loc.lng;
  }

  resetSearch(activeReset = false): void {
    if (activeReset) {
      this.locActive = false;
    } else {
      this.locActive = !this.data.new && this.data?.adrLng && this.data?.adrLat;
    }

    this.placesList = [];
    this.selectedLocation = JSON.parse(JSON.stringify(this.data));

    this.changedManuel = false;
  }

  modalAction(): void {
    this.modalService.action(this.selectedLocation);
  }

  closeModal(): void {
    if (this.newLocationArray.length > 0) {
      this.modalService.action(this.newLocationArray);
    } else {
      this.modalStyle.animation = 'zoom-out 100ms linear';
      setTimeout(() => {
        this.modalService.close();
      }, 100);
    }
  }

  dirty(): boolean {
    return this.selectedLocation.adr_enmIdent_AdresseTyp && JSON.stringify(this.data) !== JSON.stringify(this.selectedLocation);
  }

  changeManuel(): void {
    this.showManuel = !this.showManuel;
    if (!this.showManuel && this.changedManuel) {
      this.resetSearch();
    }
  }

  resetGeoCode(): void {
    this.selectedLocation.adrLat = undefined;
    this.selectedLocation.adrLng = undefined;
    this.changedManuel = true;
  }

  delete(): void {
    this.modalService.action({adrID: this.selectedLocation.adrID, del: true});
  }
}
